import {defineStore} from 'pinia'

function moneyAmountIsPositive(money) {
    return !_.isNull(money) && !_.isUndefined(money) && parseInt(money.amount, 10) > 0
}

export const useReservationStore = defineStore('reservation', {
    state: () => ({
        room: {},
        timeslots: {},
        date: null,
        time: null,
        reservationStep: null,
        discount: null,
        needsSupport: false,
        auth: false,
        csrf: null,
        reservation: null,
        terms_agreed: false
    }),
    getters: {
        selectedPricing() {
            if (_.isNull(this.time) || _.isUndefined(this.time.pricing)) {
                return null
            }

            return this.time.pricing
        },

        payablePrice() {
            if (!_.isNull(this.discount)) {
                return this.discount.discount_price
            }

            if (!_.isNull(this.selectedPricing)) {
                return this.selectedPricing.payablePrice
            }

            return _.isNull(this.time) ? null : this.time.price
        },

        paymentRequired() {
            return moneyAmountIsPositive(this.payablePrice)
        },

        voucherAllowed() {
            return !_.isNull(this.selectedPricing) ? this.selectedPricing.allowsVoucher : !_.isNull(this.time)
        },

        fundingLabel() {
            return _.isNull(this.selectedPricing) ? null : this.selectedPricing.fundingLabel
        },

        pricingNotice() {
            return _.isNull(this.selectedPricing) ? null : this.selectedPricing.notice
        },
    },
    actions: {

        setReservationStep(reservationStep) {
            this.reservationStep = reservationStep
        },

        setRoom(room) {
            this.room = room
        },

        setDate(date) {

            if (_.isNull(date)) {
                this.date = date
                return;
            }

            this.date = new Date(date).toISOString();

            this.loadTimeslots()

        },

        setTime(time) {
            const previousStartTime = _.isNull(this.time) ? null : this.time.startTime
            this.time = time

            if (previousStartTime !== time.startTime || !this.voucherAllowed) {
                this.discount = null
            }
        },

        async loadTimeslots(scrollToTimeslots = true, preserveSelectedTime = false) {
            const selectedStartTime = preserveSelectedTime && !_.isNull(this.time) ? this.time.startTime : null
            this.time = null
            this.discount = null
            this.timeslots = null

            try {
                this.timeslots = await axios.get(route('api.rooms.availability', this.room.id), {params: {date: this.date}})
                    .then((result) => result.data)

                if (!_.isNull(selectedStartTime)) {
                    this.time = this.timeslots.find((timeslot) => timeslot.startTime === selectedStartTime) ?? null
                }
            } catch (error) {

            } finally {

                if (scrollToTimeslots) {
                    setTimeout(() => {
                        let element = document.querySelector("#timeslots-top");
                        element.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }, 200)
                }
            }
        },

        setDiscount(discount) {
            this.discount = discount;
        },

        setSupport(event) {
            this.needsSupport = event.target.checked;
        },

        setTerms(event) {
            this.terms_agreed = event.target.checked;
        },

        setCSRF(value) {
            this.csrf = value
        },

        isCurrentReservation(timeslot) {
            if (_.isNull(this.reservation)) {
                return false
            }

            return this.reservation.start_time === timeslot.startTime
        },

        checkAuth(refreshPricing = false) {
            return axios.get(route('auth.check')).then(async (result) => {
                this.csrf = result.data.token
                document.querySelector('meta[name="csrf-token"]').setAttribute('content', result.data.token)
                this.auth = true

                if (refreshPricing && !_.isNull(this.date)) {
                    await this.loadTimeslots(false, true)
                }
            }).catch((error) => {
                this.auth = false
            })
        },

        reset() {
            this.room = {}
            this.timeslots = {}
            this.date = null
            this.time = null
            this.reservationStep = null
            this.discount = null
            this.auth = false
            this.reservation = null
            this.terms_agreed = false
        },

        init(room) {
            this.reset()
            this.room = room
            this.setReservationStep('date-time')
            this.setDate(new Date())
            this.checkAuth(true)
        },


        initEdit(reservation, room) {
            this.reset()
            this.reservation = reservation
            this.room = room
            this.date = reservation.start_time
            this.setReservationStep('date-time')
            this.loadTimeslots(false)
            this.checkAuth(true)
        }

    },
})
